import { DATA_TYPE_CODE } from '~/web-frontend-core/api/const/base';
import { BaseSocketConnector } from '~/web-frontend-core/api/connector/BaseSocketConnector';
export class BetsCartIrmListener extends BaseSocketConnector {
    constructor() {
        super(...arguments);
        this.dataTypeCode = DATA_TYPE_CODE.BET_CART_IRM;
        this.isConnectionSelfClosable = true;
    }
    getOutcomeData(cfg) {
        return Object.assign({ timezone: this.timezone, lng: this.language }, cfg);
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/cart/BetCartIrm.js